import { tickerItems } from "@/mocks/homeData";

export default function TopTickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="flex items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-3 py-2 md:px-5">
          <span className="live-dot h-2 w-2 shrink-0 rounded-full bg-background-50" />
          <span className="font-label text-[11px] font-semibold tracking-wide text-background-50 md:text-xs">
            实时更新
          </span>
        </div>

        <div className="relative flex min-w-0 flex-1 items-center overflow-hidden">
          <div className="ticker-track flex w-max items-center">
            {loop.map((item, index) => (
              <a
                key={`${item.time}-${index}`}
                href="#feed"
                className="flex shrink-0 items-center gap-2 whitespace-nowrap px-4 py-2 text-xs text-background-100/90 transition-colors hover:text-background-50 md:text-[13px]"
              >
                <span className="font-label text-background-300">{item.time}</span>
                {item.hot && (
                  <span className="rounded-sm bg-accent-500/20 px-1.5 py-0.5 text-[10px] font-semibold text-accent-300">
                    热
                  </span>
                )}
                <span>{item.text}</span>
                <span className="px-2 text-background-600">·</span>
              </a>
            ))}
          </div>
        </div>

        <div className="hidden shrink-0 items-center gap-2 border-l border-background-800 px-4 md:flex">
          <i className="ri-database-2-line h-4 w-4 text-background-400" style={{ lineHeight: 1 }} />
          <span className="font-label text-xs text-background-300">
            今日已更新 <span className="font-semibold text-background-50">128</span> 条
          </span>
        </div>
      </div>
    </div>
  );
}